export default __webpack_public_path__ + "static/media/hero-newport.1c554b87.webp";